import React from "react";
import "./PickemHeader.scss";
import { isMobile, isBrowser, isTablet } from 'react-device-detect';

export const PickemHeader = ({ title, subtitle, name, competitionName, competitionDescription, isDifferentUser }) => {
  
  return (
    <div className={`PickemHeader ${isMobile ? "PickemHeader-mobileDevice" : null}`}>
      <div className="PickemHeader-title">
        <div className="PickemHeader-nameBox">{title}</div>
        {subtitle || name ? <div className="PickemHeader-subtitle">{subtitle ? subtitle : null}</div> : null}
        {name && <div className={`PickemHeader-nameview ${isDifferentUser ? "PickemHeader-disabledName" : null}`}>
          <div className="PickemHeader-name">{name}</div>
          <div className="PickemHeader-competitionName">{competitionName}</div>
          <div className="PickemHeader-competitionDescription">{competitionDescription}</div>
        </div>}
        
        
      </div>
    </div>
  );
};
